"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRenderer = void 0;
const three_1 = require("three");
/**
 * antialias: false => Deactivating anti-aliasing is a simple and effective way to optimize the performance of our Three.JS application!
 * renderer.setPixelRatio( window.devicePixelRatio * 0.5 ); => This method is extremely effective, but the loss in graphic quality is significant. Thus, I suggest you use this method as a last resort!
 *
 */
function createRenderer() {
    const renderer = new three_1.WebGLRenderer({ antialias: true, alpha: true });
    // renderer.useLegacyLights = true; // Turn on the physically correct lighting model
    renderer.outputColorSpace = three_1.LinearSRGBColorSpace;
    return renderer;
}
exports.createRenderer = createRenderer;
